// What plays under the broadcast: the band, or nothing. The score lives behind sound/music.js and
// is fetched only when it is to be heard; this says whether it is, and tells the page when that changes.
import { getAmbience, music, setAmbience as choose, wantMusic } from "./music.ts";
import type { Ambience } from "./music.ts";

export { getAmbience };
export type { Ambience };

/** the bed follows the choice: the band heard when sound is on and it is chosen, else nothing; the page is told (main.js tunes the broadcast in or out) */
export const startBed = () => {
  if (wantMusic()) music.wake();
  else music.mute();
  if (typeof document !== "undefined") document.dispatchEvent(new window.Event("basho:music"));
};

export const setAmbience = (v: Ambience) => {
  choose(v);
  startBed();
};
